module.exports = __webpack_public_path__ + "img/header-memoireRingsSlim@2x.defdbd5.jpg";